var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationMarkerWithShadowYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95226 1.42493C7.50126 -0.0561486 10.6344 -0.0302616 13.1595 1.49274C15.6597 3.04676 17.1793 5.82024 17.1652 8.80371C17.107 11.7676 15.4775 14.5537 13.4408 16.7075C12.2652 17.9562 10.9501 19.0603 9.52235 19.9974C9.37531 20.0824 9.21424 20.1394 9.0471 20.1654C8.88623 20.1585 8.72957 20.111 8.59125 20.027C6.41153 18.619 4.49926 16.8217 2.94642 14.7217C1.64705 12.9686 0.90884 10.8507 0.832033 8.65552C0.830346 5.66632 2.40326 2.90601 4.95226 1.42493ZM6.42506 9.89305C6.85383 10.9501 7.86591 11.6396 8.98873 11.6396C9.72432 11.6449 10.4314 11.3503 10.9525 10.8214C11.4735 10.2924 11.7653 9.57321 11.7627 8.82391C11.7666 7.68018 11.0932 6.64683 10.057 6.20637C9.02078 5.76591 7.82608 6.00521 7.03073 6.81254C6.23539 7.61987 5.99628 8.83598 6.42506 9.89305Z",
    fill: "#ffbe00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.9974 23.6654C12.2191 23.6654 14.8307 23.143 14.8307 22.4987C14.8307 21.8544 12.2191 21.332 8.9974 21.332C5.77573 21.332 3.16406 21.8544 3.16406 22.4987C3.16406 23.143 5.77573 23.6654 8.9974 23.6654Z",
    fill: "#ffbe00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerWithShadowYellow);
export default __webpack_public_path__ + "static/media/location-marker-with-shadow--yellow.88e502d963f1918c9ea137fefe81acaa.svg";
export { ForwardRef as ReactComponent };